import DealSoftSignals from './DealSoftSignals.component';

export default DealSoftSignals;
